import { Responsive } from 'responsive/components/Responsive/Responsive'
import { useMenus } from '../../hooks/useMenus'
import { useParsedBrands } from '../../hooks/useParsedBrands'
import { Brands } from '../Brands/Brands'
import { HamburgerButton } from '../HamburgerButton/HamburgerButton'

export const OpenMenu = () => {
	const { open, updateOpen } = useMenus()

	const { parsedBrands } = useParsedBrands()

	const toggleOpen = () => {
		updateOpen(!open)
	}

	return (
		<>
			<Responsive onLessThanLarge>
				<HamburgerButton handleOpenMenu={toggleOpen} />
			</Responsive>
			<Responsive onLargeOrGreater>
				<Brands brands={parsedBrands} handleOpenMenu={toggleOpen} />
			</Responsive>
		</>
	)
}
